<!doctype html>
<html lang="en-us">
  <head>
    <meta charset="utf-8" />
    <title>bricks demo</title>
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <link rel="stylesheet" href="./demo-app/styles.css" />
  </head>
  <body>
    <script type="module">
      import { App } from "./demo-app/app";

      App.create({});
    </script>
  </body>
</html>
